import * as React from 'react'
// import * as classnames from 'classnames'

import * as styles from './submenuOverlay.css'

import { StoreComponent, injectStores } from '../../../store'
import { observer } from 'mobx-react'
import posed from 'react-pose'
import { BackButton } from '../elements/buttons'
import { ContentMenu } from '../../imprintSources/impressum'
import { Quellen } from 'src/modules/imprintSources/quellen'

const submenuProps = {
  open: { x: '0%', opacity: 1, transition: { duration: 300, ease: 'easeOut' } },
  closed: { x: '100%', opacity: 0, transition: { duration: 300, ease: 'easeIn' } }
}

const Sidebar = posed.div(submenuProps)

interface IProps {
  open: boolean
  onBackClick: () => void
}

@injectStores
@observer
export class SubmenuOverlay extends StoreComponent<IProps> {

  render () {

    let content: JSX.Element | null = null
    if (this.props.open) {
      content = <React.Fragment>
                  <div className={styles.backButtonBox}>
                    <BackButton className={styles.backButton} onClick={this.props.onBackClick} />
                    {this.store.breakpoints.phone && <div className={styles.submenuTitle}>{this.store.storeCommon.menu.submenuType}</div>}
                  </div>
                  {this.store.storeCommon.menu.submenuType && (this.store.storeCommon.menu.submenuType === 'quellen' || this.store.storeCommon.menu.submenuType === 'sources' ? <Quellen /> : <ContentMenu type={this.store.storeCommon.menu.submenuType} />)}
                </React.Fragment>
    }
    return (
      <Sidebar
        pose={this.props.open ? 'open' : 'closed'}
        key='submenu'
        className={styles.submenuContainer}
        withParent={false}
        initialPose='closed'
        style={{ height: this.store.breakpoints.desktop ? this.store.storeCommon.window.height : this.store.storeCommon.window.height - 50 }}
      >
        {content}
      </Sidebar>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/header/submenuOverlay.tsx